import { SVGProps } from "react";

export function Package({ className }: SVGProps<SVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7708 1.57045C5.95379 1.4648 6.16138 1.40918 6.37268 1.40918C6.58399 1.40918 6.79157 1.4648 6.97457 1.57045L10.0052 3.32025C10.1882 3.4259 10.3401 3.57786 10.4458 3.76085C10.5514 3.94384 10.6071 4.15142 10.6071 4.36272V7.86231C10.6071 8.07361 10.5514 8.28119 10.4458 8.46418C10.3401 8.64717 10.1882 8.79912 10.0052 8.90477L6.97457 10.6546C6.79157 10.7602 6.58399 10.8158 6.37268 10.8158C6.16138 10.8158 5.95379 10.7602 5.7708 10.6546L2.74019 8.90477C2.5572 8.79912 2.40524 8.64717 2.29959 8.46418C2.19394 8.28119 2.13831 8.07361 2.13831 7.86231V4.36272C2.13831 4.15142 2.19394 3.94384 2.29959 3.76085C2.40524 3.57786 2.5572 3.4259 2.74019 3.32025L5.7708 1.57045ZM4.4558 4.44987L7.24758 2.84019L8.21108 3.39633L5.4193 5.00601L4.4558 4.44987Z"
        fill="currentColor"
      />
    </svg>
  );
}
